import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Apis } from './API';

@Injectable({
    providedIn: 'root',
})
export class DashboardService {
    constructor(private apiService: ApiService) {}

    /**
     * Get dashboard statistics with filters
     * @param filters - Filter object with flag_today, year, and month
     * @returns Observable with dashboard statistics
     */
    getDashboardStats(filters?: { flag_today?: boolean; year?: number | null; month?: number | null }) {
        let url = `${Apis.dashboard.dashboard_stats}`;

        // Add query parameters
        const params = new URLSearchParams();

        // Ajouter flag_today (par défaut false)
        const flagToday = filters?.flag_today ?? false;
        params.append('flag_today', flagToday.toString());

        // Ajouter year et month seulement si flag_today est false
        if (!flagToday) {
            if (filters?.year !== undefined) {
                params.append('year', filters.year?.toString() || 'null');
            }

            if (filters?.month !== undefined) {
                params.append('month', filters.month?.toString() || 'null');
            }
        }

        url += `?${params.toString()}`;
        return this.apiService.get(url);
    }

    /**
     * Get dashboard statistics for a specific period
     * @param year - The year to filter by
     * @param month - Optional month to filter by (1-12)
     * @returns Observable with dashboard statistics
     */
    getDashboardStatsByPeriod(year: number | null, month?: number | null) {
        return this.getDashboardStats({
            flag_today: false,
            year,
            month
        });
    }

    /**
     * Get dashboard statistics for today
     * @returns Observable with dashboard statistics
     */
    getTodayStats() {
        return this.getDashboardStats({ flag_today: true });
    }

    /**
     * Get dashboard statistics for all data
     * @returns Observable with dashboard statistics
     */
    getAllStats() {
        return this.getDashboardStats({
            flag_today: false,
            year: null,
            month: null
        });
    }
}